import React from "react";
import { Link } from "react-router-dom";

export const LegalImprint = () => {
  return (
    <div className="bg-ink text-bone min-h-screen pt-32 pb-20 px-5 md:px-14 lg:px-20 font-serif">
      <div className="max-w-3xl mx-auto space-y-12">
        <header className="space-y-4 border-b border-bone/10 pb-8">
          <p className="label text-stone tracking-[0.25em] text-xs uppercase">Legal Information</p>
          <h1 className="text-4xl md:text-5xl font-light text-bone">Legal Imprint</h1>
        </header>

        <section className="space-y-8 text-stone font-sans text-sm leading-relaxed font-light">
          <div>
            <h2 className="text-bone font-serif text-lg mb-2">1. Brand & Business Operator</h2>
            <p><strong className="text-bone">ALKEON Timeless Design</strong> is a proprietary brand and project operated by:</p>
            <p className="mt-2 text-bone">PS3D CREATIVE di Sampaolesi Pierpaolo</p>
          </div>

          <div>
            <h2 className="text-bone font-serif text-lg mb-2">2. Registered Office & Contact</h2>
            <p>Largo Monte Cardosa 4, 62019 Recanati (MC), Italy</p>
            <p className="mt-1">Email: <a href="mailto:info@alkeontimelessdesign.com" className="text-bone underline underline-offset-4 hover:text-sand">info@alkeontimelessdesign.com</a></p>
          </div>

          <div>
            <h2 className="text-bone font-serif text-lg mb-2">3. Tax Identification</h2>
            <p>VAT ID / P.IVA: <span className="text-bone">IT02117040432</span></p>
            <p className="mt-1">Tax Regime: Regime Forfettario (Italian Law No. 190/2014, as amended)</p>
          </div>

          <div>
            <h2 className="text-bone font-serif text-lg mb-2">4. Intellectual Property</h2>
            <p>
              All original content published on this website—including proprietary text, photographs, 3D renderings, and product designs—is protected under applicable intellectual property and copyright laws. Unauthorized reproduction, distribution, or commercial use without prior written consent is strictly prohibited. Third-party assets or fonts are utilized under respective licenses.
            </p>
          </div>
        </section>

        <div className="pt-8 border-t border-bone/10">
          <Link to="/" className="label text-xs tracking-widest text-stone hover:text-bone transition-colors uppercase">
            &larr; Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LegalImprint;